export const defaultState = {
    id: '',
    user: '',
    signature: null,
    dateFrom: null,
    signatureType: 'N',
    assessorType: null,
};

const SET_EDIT_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });
export const updateFieldCreator = ({ name, value, dataType }) => ({
    type: UPDATE_FIELD,
    payload: { name, value, dataType },
});

const reducer = (state = defaultState, action) => {
    if (action.type === SET_EDIT_DATA) {
        return {
            ...state,
            ...action.payload,
            dateFrom: action.payload.dateFrom ? new Date(action.payload.dateFrom) : null,
            signature: {name: action.payload.signatureFilename, fileName: action.payload.signaturePath},
            selectedUser: action.payload.user ? {value: action.payload.user.id, label: `${action.payload.user.firstName} ${action.payload.user.lastName}`} : null,
            assessorType: action.payload.assessorType,
        };
    }
    if (action.type === UPDATE_FIELD) {
        return { ...state, [action.payload.name]: action.payload.value };
    }
    return state;
};

export default reducer;